import {
	POST_COMPANY_SETTINGS_ATTENDANCE,
	POST_COMPANY_SETTINGS_ATTENDANCE_ERROR,
    POST_COMPANY_SETTINGS_ATTENDANCE_SUCCESS,
} from '../../constants';

export const postCompanyAttendanceReducer = (state, actions) => {
	switch (actions.type) {
		case POST_COMPANY_SETTINGS_ATTENDANCE:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_COMPANY_SETTINGS_ATTENDANCE_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_COMPANY_SETTINGS_ATTENDANCE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				companies: actions.payload,
			};
		default:
			return state;
	}
};
